import React, { Component } from 'react';
import { Table } from 'semantic-ui-react';
import TableItems from './items/tableItems';
import Pagination from '../pagination/Pagination';

const options = [
  { key: '1', text: '10 por página', value: 10 },
  { key: '2', text: '20 por página', value: 20 },
  { key: '3', text: '50 por página', value: 50 },
  { key: '4', text: '100 por página', value: 100 }
];

class TableHistoric extends Component {
  constructor(props) {
    super(props);
    this.state = { pageOfItems: [], itemsPerPage: 10 };
    this.onChangePage = this.onChangePage.bind(this);
  }

  onChangePage(pageOfItems) {
    this.setState({ pageOfItems: pageOfItems });
    this.props.getChartItems(pageOfItems);
  }

  render() {
    const { chart, goToRef } = this.props;
    const { pageOfItems, itemsPerPage } = this.state;

    return (
      <div>
        <Table unstackable compact fixed singleLine size="small">
          <Table.Header>
            <Table.Row as="tr">
              <Table.HeaderCell>Orden</Table.HeaderCell>
              <Table.HeaderCell>Fecha</Table.HeaderCell>
              <Table.HeaderCell>Resultado</Table.HeaderCell>
              <Table.HeaderCell>Unidad</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {pageOfItems.map((item, index) => (
              <TableItems key={item.orden} item={item} />
            ))}
          </Table.Body>
        </Table>
        <div align="center">
          <Pagination
            items={chart.data}
            itemsPerPage={itemsPerPage}
            onChangePage={this.onChangePage}
            options={options}
            goToRef={goToRef}
          />
        </div>
      </div>
    );
  }
}

export default TableHistoric;
